import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";

import Header_Supervisor from "../../Components/Header_Supervisor";
import Supervisor_Agent from '../../Pages/Supervisor/Supervisor_Agent';

const Company_Team = () => {
  const [activeTab, setActiveTab] = useState('agent'); // Supervisor default

  useEffect(() => {
    const storedUserData = sessionStorage.getItem("user");

    if (!storedUserData) {
      Swal.fire("Error", "No user data found in sessionStorage.", "error");
    }
  }, []);

  return (
    <div className="container-fluid">

      {/* Header */}
      <Header_Supervisor />

      {/* Tabs */}
      <ul className="nav nav-tabs mt-3">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === 'agent' ? 'active' : ''}`}
            onClick={() => setActiveTab('agent')}
          >
            Company Agent
          </button>
        </li>
      </ul>

      {/* Tab Content */}
      <div className="tab-content mt-4">
        {activeTab === 'agent' && (
          <div className="tab-pane fade show active">
            <Supervisor_Agent />
          </div>
        )}
      </div>
    </div>
  );
};

export default Company_Team;